export default __webpack_public_path__ + "static/media/radio-none-design.56354bbd.svg";